<template>
    <div>
        <navTitle title="IM Club Lottery" :ask="true" askName="club_lottery" :tip_msg="tip_msg"/>
        <div v-if="page_init" class="con">
            <div class="club-open">
                <div class="club-points">
                    <lable class="club-points-icon">🌟</lable>
                    <lable class="club-points-det">
                        {{club_points_info['current_points']}}/{{club_points_info['accumulated_points']}}
                    </lable>
                    <b @click="showPopupClub">
                        <svg t="1700462139458" class="icon" viewBox="0 0 1024 1024" version="1.1"
                             xmlns="http://www.w3.org/2000/svg" p-id="10202" width="32" height="32">
                            <path d="M0 0h1024v1024H0z" fill="#FFFFFF" fill-opacity="0" p-id="10203"></path>
                            <path d="M510.045 0C228.352 0 0 228.352 0 510.045c0 281.67 228.352 509.999 510.045 509.999 281.67 0 510.022-228.352 510.022-510.022C1020.067 228.352 791.738 0 510.045 0z m0 792.972a56.576 56.576 0 1 1 0-113.176 56.576 56.576 0 0 1 0 113.176z m28.276-229.4c0 31.349-12.986 56.576-28.276 56.576s-28.3-25.227-28.3-56.576l-28.3-251.578a56.576 56.576 0 0 1 113.176 0l-28.3 251.578z"
                                  fill="#F7A200" p-id="10204"></path>
                        </svg>
                    </b>
                </div>
                <mt-popup class="popup-visible" v-model="popupVisible">
                    <div class="popup-content">
                        <div>Xếp hạng sao của câu lạc bộ: Số sao hiện có/tổng số sao</div>
                        <p>Hoàn thành nhiệm vụ để tích lũy sao</p>
                        <p>Các ngôi sao có thể được đổi lấy giải thưởng hoặc thời gian tham gia câu lạc bộ</p>
                        <p>Tổng số sao cũng là biểu tượng của địa vị. Khi tích lũy được số lượng sao nhất định, bạn có thể được hưởng các quyền lợi ở cấp độ tương ứng</p>
                    </div>
                </mt-popup>
                <!--中奖公告-->
                <div class="lottery-tip" @click="openWinList">
                    <div class="win-title">Người chiến thắng tháng trước</div>
                    <div v-if="win_user.length>0">
                        <label class="no-1">Người đoạt giải nhất: ID {{win_user[0]['uid']}} Get
                            {{win_user[0]['type']===1?'thưởng':'giải thưởng'}} {{win_user[0]['g_name']}}</label>
                        <label class="no-2">Người đoạt giải Nhì: ID {{win_user[1]['uid']}} Get
                            {{win_user[1]['type']===1?'thưởng':'giải thưởng'}} {{win_user[1]['g_name']}}</label>
                        <label class="no-3">Người đoạt giải ba: ID {{win_user[2]['uid']}} Get
                            {{win_user[2]['type']===1?'thưởng':'giải thưởng'}} {{win_user[2]['g_name']}}</label>
                    </div>
                    <div class="no-win-user" v-else>
                        Không có giải thưởng nào được rút ra vào tháng trước
                    </div>
                    <hr>
                    <div class="open-con">
                        <div class="win-title">Thời gian quay xổ số tháng này</div>
                        <div class="open-time">{{nm}}</div>
                    </div>
                </div>
                <!--中奖纪录-->
                <mt-popup class="popup-visible win-list" v-model="win_list_false">
                    <table style="width: 100%;border: 1px;text-align: center;height: 100%;">
                        <tr style="background-color: #00C3F9;color: #fff">
                            <td>UID</td>
                            <td>Phần thưởng</td>
                            <td>Ngày giờ</td>
                        </tr>
                        <tr v-for="v in win_user_all">
                            <td>{{v.uid}}</td>
                            <td>{{v.g_name}}</td>
                            <td>{{v._add_time}}</td>
                        </tr>
                    </table>
                </mt-popup>
                <!--奖品列表-->
                <div class="goods-con">
                    <div class="prize-con" v-for="v in goods" @click="exchange(v)">
                        <div class="prize-img-info">
                            <img class="prize-img" :src="v.image">
                        </div>
                        <div class="prize-info">
                            <div class="prize-name">{{JSON.parse(v.name)}}</div>
                            <div class="prize-pay-limit">ER: Tích lũy 🌟{{v.star_limit}}</div>
                            <div class="prize-price">Tiêu thụ:🌟{{v.star_pay}}</div>
                        </div>
                    </div>
                </div>
                <div style="clear:both;"></div>
                <!--我的订单-->
                <div class="my-order-record" v-if="my_record_list.length>0">
                    <table style="width: 100%;border: 1px;text-align: center;height: 100%;">
                        <thead>
                        <tr style="background-color: #00C3F9;color: #fff;height: 32px;">
                            <th style="border-top-left-radius: 5px;">Phần thưởng</th>
                            <th>Tiêu thụ</th>
                            <th>Ngày giờ</th>
                            <th>Thắng</th>
                            <th style="border-top-right-radius: 5px;">Vận hành</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="v in my_record_list" style="height: 30px">
                            <td>{{v.g_name}}</td>
                            <td>🌟{{v.order_price}}</td>
                            <td>{{v._add_time}}</td>
                            <td>{{v.is_win===1?'Đúng':'KHÔNG'}}</td>
                            <td>
                                <Button v-if="v['is_win']===1&&v['is_return']===0" class="win-receive-btn"
                                        type="primary" size="small"
                                        @click="returnAward(v)">Nhận được
                                </Button>
                                <div class="on-open-tip" v-else-if="v['is_m']===1">ChưaVẽChưa</div>
                                <div v-else-if="v['is_win']===0&&v['is_m']===0">--</div>
                                <Button v-else-if="v['is_win']===1&&v['type']===2&&v['is_return']===1"
                                        class="win-receive-btn" type="primary" size="small" @click="checkLogistics(v)">
                                    hậu cần
                                </Button>
                                <Button v-else class="win-receive-btn" type="primary" size="small" disabled>Đã nhận
                                </Button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <!--领取奖品-->
                <mt-popup class="popup-visible address-area" v-model="prize_false">
                    <mt-field class="input-code" type="number" label="Phone" placeholder="phone"
                              v-model="phone"></mt-field>
                    <mt-field class="input-code" type="textarea" rows="6" label="Address"
                              placeholder="Recipient's name, street address or house number, district (or town) name, city name, province name, postal code"
                              v-model="address"></mt-field>
                    <div class="prize-tip">Lời khuyên loại: Vui lòng liên hệ với bộ phận dịch vụ khách hàng để xác nhận tính chính xác và
                        tính xác thực của địa chỉ giao hàng
                    </div>
                    <div class="prize-btn">
                        <Button class="prize-receive-btn" type="primary" size="small" @click="returnPrize()">
                            Xác nhận
                        </Button>
                    </div>
                </mt-popup>
            </div>
        </div>
    </div>
</template>

<script>
    import navTitle from "../../components/navTitle"
    import {Button, Field, Popup} from 'mint-ui'
    import 'mint-ui/lib/style.css'
    import {
        getClubAwardInfo,
        returnAward,
        getGoods,
        getOrder,
        createOrder
    } from "../../api/activity"
    import {DebounceBy} from "../../api/user"

    export default {
        name: "ClubLottery",
        components: {
            navTitle,
            Button,
            'mt-field': Field,
            'mt-popup': Popup
        },
        data() {
            return {
                page_init: false,
                popupVisible: false,
                win_list_false: false,
                prize_false: false,
                club_points_info: '',
                win_user: [],
                win_user_all: [],
                my_record_list: [],
                nm: '',
                param_prize: '',
                phone: '',
                address: '',
                tip_msg: '',
                goods: []
            }
        },
        mounted: function () {
            this.getClubInfo()
            this.getGoodsList()
            this.getOrderList()
        },
        methods: {
            showPopupClub() {
                this.popupVisible = !this.popupVisible
            },
            openWinList() {
                this.win_list_false = !this.win_list_false
            },
            getClubInfo() {
                let that = this
                getClubAwardInfo().then(res => {
                    that.page_init = true
                    that.club_points_info = res.data.club_points_info
                })
            },
            getGoodsList() {
                let that = this
                getGoods().then(res => {
                    that.goods = res.data.res
                    that.tip_msg = res.data.club_lottery_rules
                })
            },
            getOrderList() {
                let that = this
                getOrder().then(res => {
                    // console.log(res)
                    that.win_user = res.data.win_user[0]
                    that.win_user_all = res.data.win_user[1]
                    that.my_record_list = res.data.user_order
                    that.nm = res.data.nm
                })
            },
            // 抽奖券兑换
            exchange: DebounceBy(function (v) {
                let that = this
                let msg = 'Để đổi vé số, bạn cần tích lũy 🌟' + v.star_limit + ' và tiêu thụ 🌟' + v.star_pay + ' hiện tại, Bạn có xác nhận việc đổi vé không?'
                this.$dialog.confirm({
                    mes: msg,
                    title: 'Mẹo đổi thưởng',
                    opts: [
                        {
                            txt: 'Hủy bỏ',
                            color: "#ddd",
                            callback: () => {
                                return this.$dialog.toast({mes: 'Canceled'});
                            }
                        },
                        {
                            txt: 'Xác nhận',
                            color: "#00C3F9",
                            callback: () => {
                                // console.log(v)
                                // return
                                that.$dialog.loading.open('loading...')
                                let param = {goods_id: v.id}
                                createOrder(param).then(res => {
                                    // console.log(res)
                                    that.$dialog.loading.close();
                                    that.$dialog.toast({mes: res.msg})
                                    that.getClubInfo()
                                    that.getOrderList()
                                }).catch(res => {
                                    // console.log(res)
                                    that.$dialog.loading.close();
                                    that.$dialog.toast({mes: res.msg});
                                });
                            }
                        }
                    ]
                });
            }, 3000),
            // 领奖
            returnAward(v) {
                if (v.type === 2) {
                    this.param_prize = v
                    this.prize_false = !this.prize_false
                } else {
                    let that = this
                    let msg = 'Chúc mừng bạn đã chiến thắng, nhận ' + v.g_name + ' ngay!!!'
                    this.$dialog.confirm({
                        mes: msg,
                        title: 'Mẹo đổi thưởng',
                        opts: [
                            {
                                txt: 'Hủy bỏ',
                                color: false,
                                callback: () => {
                                    return this.$dialog.toast({mes: 'Canceled'});
                                }
                            },
                            {
                                txt: 'Xác nhận',
                                color: "#00C3F9",
                                callback: () => {
                                    let param = {id: v.id, g_id: v.g_id, order_no: v.order_no, level: v.level}
                                    that.returnClubAward(param)
                                }
                            }
                        ]
                    });
                }
            },
            returnPrize() {
                if (this.phone === '' || this.address === '')
                    return this.$dialog.toast({mes: 'Lỗi tham số'});
                let v = this.param_prize
                let param = {
                    id: v.id,
                    g_id: v.g_id,
                    order_no: v.order_no,
                    level: v.level,
                    phone: this.phone,
                    address: this.address
                }
                this.returnClubAward(param)
                this.prize_false = !this.prize_false
            },
            // 领取奖励
            returnClubAward: DebounceBy(function (param) {
                let that = this
                that.$dialog.loading.open('loading...')
                returnAward(param).then(res => {
                    // console.log(res)
                    that.$dialog.loading.close();
                    that.$dialog.toast({mes: res.msg})
                    that.getClubInfo()
                    that.getOrderList()
                }).catch(res => {
                    // console.log(res)
                    that.$dialog.loading.close();
                    that.$dialog.toast({mes: res.msg});
                });
            }, 2000),
            // 查看物流
            checkLogistics: DebounceBy(function (v) {
                let msg = v.remark
                this.$dialog.confirm({
                    mes: msg,
                    title: 'Thông tin hậu cần',
                    opts: [
                        {
                            txt: 'Xác nhận',
                            color: "#00C3F9",
                            callback: () => {
                            }
                        }
                    ]
                });
            }, 2000)
        }
    }
</script>

<style scoped>
    .con {
        height: 1500px;
        margin-top: 1rem;
        background: #59316b;
        /*background: #4B0082;*/
        padding-bottom: 10px;
        margin-bottom: 50px;
    }

    .club-open {
        position: absolute;
        width: 100%;
        height: 1500px;
        background-image: url("../../assets/images/bg.png");
        background-size: contain;
        /*background-repeat: no-repeat;*/
        /*background-position: center;*/
        background-repeat: repeat-x;
        padding-bottom: 10px;
        margin-bottom: 10px;
    }

    p::before {
        content: "●";
        margin-right: 5px; /* 可选：为了添加一些间距 */
    }

    .club-points-icon {
        font-size: 20px;
    }

    .club-points {
        position: absolute;
        right: 0;
        color: #fff;
        padding-right: 5px;
        padding-top: 3px;
        z-index: 99;
    }

    .popup-visible {
        border-radius: 3px;
    }

    .popup-content {
        width: 350px;
        padding: 5px;
        font-size: 12px;
        color: #2F4F4F;
    }

    .lottery-tip {
        position: relative;
        width: 100%;
        font-size: .22rem;
        padding: .2rem 0;
        background: rgba(138, 43, 226, 0.6);
        color: #F8F8FF;
        margin-top: 30px;
        text-align: center;
    }

    .win-list {
        width: 70%;
        padding: 5px 3px;
        color: #3a3a3a;
    }

    .win-title {
        padding-bottom: 3px;
        font-size: .3rem;
        font-weight: bold;
        text-shadow: 0 0 10px #fff, 0 0 20px #fff, 0 0 30px #fff;
    }

    hr {
        width: 94%;
        margin-left: 3%;
        margin-top: 6px;
        padding: 6px 0;
        border: none;
        border-top: 1px dashed #ccc;
    }

    .open-time {
        padding-top: 5px;
        color: red;
        font-weight: bold;
        font-size: .35rem;
    }

    .no-1, .no-2, .no-3 {
        padding-bottom: 3px;
        /*border: 1px solid red;*/
        display: block;
        /*width: 75%;*/
        /*width: 100%;*/
    }

    .no-1 {
        color: #FFD700;
        text-shadow: 0 0 10px #FFD700, 0 0 20px #FFD700, 0 0 30px #FFD700;
    }

    .no-2 {
        color: #DCDCDC;
        text-shadow: 0 0 10px #DCDCDC, 0 0 20px #DCDCDC, 0 0 30px #DCDCDC;
    }

    .no-3 {
        color: #DAA520;
        text-shadow: 0 0 10px #DAA520, 0 0 20px #DAA520, 0 0 30px #DAA520;
    }

    .goods-con {
        /*position: relative;*/
        margin-top: 10px;
        /*width: 280px;*/
        /*padding: 8px;*/
        /*display: flex;*/
        /*align-items: center;*/
        /*justify-content: center;*/
    }

    /*商品列表*/
    .prize-con {
        width: 30%;
        display: flex;
        flex-direction: column;
        float: left;
        margin-left: 2.5%;
        font-size: 14px;
        text-align: center;
        background-color: rgba(248, 248, 255, 0.4);
        border-radius: 5px;
        -webkit-box-shadow: 2px 2px 10px #fff;
        box-shadow: 2px 2px 10px #fff;
    }

    .prize-img {
        width: 100%;
    }

    .prize-info {
        text-align: left;
        padding: 5px;
    }

    .prize-name {
        font-weight: bold;
        color: #fff;
        font-size: .22rem;
    }

    .prize-price {
        color: #f73e46;
    }

    .prize-pay-limit {
        color: #98FB98;
        /*font-size: .21rem;*/
    }

    .my-order-record {
        position: relative;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        width: 98%;
        margin-left: 1%;
        margin-top: 12px;
        background: rgba(255, 255, 255, 0.6);
    }

    .on-open-tip {
        font-size: .2rem;
        color: #00c3f9;
    }

    .win-receive-btn {
        height: 20px;
        background-color: #00c3f9 !important;
    }

    .address-area {
        width: 85%;
    }

    .prize-tip {
        font-size: .15rem;
        color: red;
        padding: 0 5px 8px 5px;
    }

    .prize-btn {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .prize-receive-btn {
        background-color: #00c3f9;
        margin-top: -5px;
        margin-bottom: 5px;
    }
    .no-win-user{
        color: darkgrey;
        font-size: 12px;
    }
</style>